/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CurrencyRestrictionType {
  None = 'None',
  Base = 'Base',
  Foreign = 'Foreign'
}
